import React, { FC, Fragment, useState } from 'react'
import { Card, Row, Col, Switch, Empty, Image } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import { toast } from 'react-toastify'
import PrefixService from "../../../services/prefix"
import { requestAuthInit } from '../../../store/auth/auth.actions'
// import { ApplicationState } from '../../../store'
import { ThunkDispatch } from '../../../@types/store'
import FormattedMessage from '../../Elements/FormattedMessage'
import { FuncFormattedMessage } from '../../../utils/FuncFormattedMessage'

const { Meta } = Card;

interface ListProps {
    dataSource: any
    loading?: boolean
    handleEdit: (e: string) => void
}

const PromotionBonus: FC<ListProps> = ({ dataSource, loading, handleEdit }) => {
    const dispatch: ThunkDispatch<AnyAction> = useDispatch()
    const [switchLoading, setSwitchLoading] = useState(false)


    const textHandleDelete = {
        title: FuncFormattedMessage("handleDelete.title", "แจ้งเตือน!"),
        text: FuncFormattedMessage("handleDelete.text", "คุณต้องการลบรายการนี้ใช่หรือไม่"),
        confirm: FuncFormattedMessage("confirm", "ตกลง"),
        cancel: FuncFormattedMessage("cancel", "ยกเลิก"),
    }

    const handleDelete = (keyBonus: string) => {
        Swal.fire({
            title: `${textHandleDelete.title}`,
            text: `${textHandleDelete.text}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: textHandleDelete.cancel,
            confirmButtonText: textHandleDelete.confirm,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await PrefixService.deletePromotionConfig(keyBonus)
                    dispatch(requestAuthInit(false))
                    toast.success(res.message)
                } catch ({ message }) {
                    toast.error(message as string)
                }
            }
        })
    };

    const handleStatus = async (status: boolean, keyBonus: string, item: any) => {
        if (keyBonus) {
            try {
                item.enable = status
                const res = await PrefixService.savePromotionConfig(keyBonus, item)
                dispatch(requestAuthInit(false))
                toast.success(res.message)
            } catch ({ message }) {
                toast.error(message as string)
            }
            setSwitchLoading(false)
        }
    };

    const listCard = dataSource.length !== 0 ? dataSource.map((item: any, idx: any) => {

        const nameBonus = item.order !== 0 ? `(${item.order}) ${item.name}` : item.name

        return (
            <Col md={12} xl={8} offset={0.5} key={`col-${idx}`}>
                <Card
                    key={idx}
                    className="box-white box-promotion"
                    bordered={false}
                    cover={
                        <Image
                            alt={item.name}
                            src={item.image ? item.image : 'error'}
                            fallback="data:image/png;base64,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"
                        />
                    }
                    actions={[
                        <Switch
                            checkedChildren={<FormattedMessage id="open" defaultMessage="เปิด" />}
                            unCheckedChildren={<FormattedMessage id="close" defaultMessage="ปิด" />}
                            checked={item.enable}
                            loading={switchLoading}
                            onChange={(e) => {
                                setSwitchLoading(true)
                                handleStatus(e, item.key, item)
                            }}
                        />,
                        <EditOutlined key="edit" style={{ color: 'var(--text-primary)' }}
                            onClick={() => { handleEdit(item.key) }}
                        />,
                        <DeleteOutlined key="delete" style={{ color: 'var(--text-primary)' }} onClick={() => handleDelete(item.key)} />,
                    ]}
                    loading={loading}
                >
                    {/* {item.enable ? <i className="fa-solid fa-circle mr-1 text-success" /> : <i className="fa-solid fa-circle mr-1 text-danger" />} */}
                    <Meta
                        title={nameBonus}
                        description={item.description}
                    />
                </Card>
            </Col>
        )
    }) : (
        <div style={{ margin: "0 auto" }}>
            <Empty description="ไม่มีข้อมูล" />
        </div>
    )

    return (
        <Fragment>
            <Row gutter={[16, 24]}>
                {listCard}
            </Row>
        </Fragment>
    )
}

export default PromotionBonus